
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import BmContent from './content/bmContent.vue'
import JxtxContent from './content/jxtxContent.vue'
import KczcContent from './content/kczcContent.vue'
import KcxzContent from './content/kcxzContent.vue'
import ShowContent from './content/showContent.vue'

@Component({
  components: {
    BmContent,
    JxtxContent,
    KczcContent,
    KcxzContent,
    ShowContent,
    LazyImg
  }
})
export default class extends Vue {
  tabIndex: number = 0

  currentComponent: string = 'BmContent'

  getCurrentComponent(index: number) {
    switch (index) {
      case 0:
        this.currentComponent = 'BmContent'
        return
      case 1:
        this.currentComponent = 'JxtxContent'
        return
      case 2:
        this.currentComponent = 'KczcContent'
        return
      case 3:
        this.currentComponent = 'KcxzContent'
        return
      case 4:
        this.currentComponent = 'ShowContent'
        return
      default:
        this.currentComponent = 'BmContent'
        return
    }
  }

  changeTab(index: number) {
    if (this.tabIndex === index) return

    this.tabIndex = index

    this.getCurrentComponent(index)
  }

  handleMore() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
